import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_CONFIGS } from '../seo/routes';
import PopularRouteCardsPure from '../seo/content/PopularRouteCards';

const RouterLink = ({ href, className, children }) => (
  <Link to={href} className={className}>
    {children}
  </Link>
);

// Plain link list for the footer's "Popular Routes" column — mirrors the
// styling of the other footer link lists (Quick Links / Company).
export const PopularRouteLinks = () => (
  <ul className="space-y-4 text-sm text-stone-400">
    {ROUTE_CONFIGS.map((route) => (
      <li key={route.slug}>
        <Link to={`/${route.slug}`} className="hover:text-white transition-colors">
          {route.breadcrumbLabel}{route.kind === 'private' ? ' Private Transfer' : ' Shuttle'}
        </Link>
      </li>
    ))}
  </ul>
);

// Card grid for the homepage "Popular routes" section — matches the product
// card aesthetic used elsewhere on Home.jsx.
export const PopularRouteCards = () => <PopularRouteCardsPure LinkComponent={RouterLink} />;

export default PopularRouteCards;
